export const envUrlMap: Record<string, string> = {
  local: "http://localhost:8000",
  development: "https://dev.ss-stage.com",
  staging: "https://staging.ss-stage.com",
  hotfix: "https://hotfix.ss-stage.com",
  production: "https://app.smartsuite.com",
};

export const getEnvBaseUrl = (env: string): string => {
  return envUrlMap[env] ?? envUrlMap.production;
};
